var ACTIONS = {
  SET_USER_TAGS: 'SET_USER_TAGS'
};
export default ACTIONS;